import { Container, Point, Sprite, Text, Texture } from "pixi.js";
import { LatestNewsResourcePackage } from "../resources/LatestNewsResourcePackage";
import { NewsTextStyle } from "./styles/NewsTextStyle";
import { UpgradeItemElementType } from "../../../common/models/Building/types/UpgradeItemElementType";
import { StringFormatExtention } from "../../../../../extensions/StringFormatExtention";

export enum CurrencyType {
    COINS = 'COINS',
    TOKEN = 'TOKEN',
    APPLE = 'APPLE',
    ORANGE = 'ORANGE',
    STRAWBERRY = 'STRAWBERRY'
}

export class NewsCurrencyComponent extends Container {
    private static readonly CURRENCY_TEXTURE: Map<CurrencyType | UpgradeItemElementType, keyof LatestNewsResourcePackage> = new Map([
        [CurrencyType.COINS, "assets_views_latest_news_coin_png"],
        [CurrencyType.TOKEN, "assets_views_latest_news_token_png"],
        [CurrencyType.APPLE, "assets_views_latest_news_gold_png"],
        [CurrencyType.ORANGE, "assets_views_latest_news_diamond_green_png"],
        [CurrencyType.STRAWBERRY, "assets_views_latest_news_diamond_purple_png"]
    ]);
    private static readonly CURRENCY_ICON_POSITION: Map<CurrencyType | UpgradeItemElementType, Point> = new Map([
        [CurrencyType.COINS, new Point(3, 2)],
        [CurrencyType.TOKEN, new Point(0, 0)],
        [CurrencyType.APPLE, new Point(-1, -10)],
        [CurrencyType.ORANGE, new Point(-8, -13)],
        [CurrencyType.STRAWBERRY, new Point(-1, -7)]
    ]);
    private howMuchText: Text;
    private currencyIcon: Sprite;

    public constructor(newsResources: LatestNewsResourcePackage, currencyNumber: number, type: CurrencyType | UpgradeItemElementType) {
        super();
        this.howMuchText = new Text(StringFormatExtention.formatWithComma(currencyNumber), new NewsTextStyle());
        if (type === CurrencyType.TOKEN) {
            let formattedTokenAmount: string;
            const tokenAmount = parseFloat(currencyNumber.toString());
            if (Number.isInteger(tokenAmount)) {
                formattedTokenAmount = StringFormatExtention.formatWithComma(tokenAmount.toString());
            } else {
                const fixedTokenAmount = tokenAmount.toFixed(4);
                formattedTokenAmount = StringFormatExtention.formatWithComma(parseFloat(fixedTokenAmount).toString());
            }
            this.howMuchText.text =  formattedTokenAmount;
        }
        const currencyIconTexture = this.generateCurrencyTexture(newsResources, type);
        this.currencyIcon = new Sprite(currencyIconTexture);
        const currencyIconPosition = NewsCurrencyComponent.CURRENCY_ICON_POSITION.get(type);
        this.currencyIcon.position.set(this.howMuchText.width + currencyIconPosition.x, currencyIconPosition.y);
        this.addChild(this.howMuchText, this.currencyIcon);
    }

    private generateCurrencyTexture(newsResources: LatestNewsResourcePackage, type: CurrencyType | UpgradeItemElementType): Texture {
        const resourceProperty = NewsCurrencyComponent.CURRENCY_TEXTURE.get(type);
        return newsResources[resourceProperty] as Texture;
    }
}
